<div class="auth-card">
  <!-- Logo -->
  <a routerLink="/" class="auth-logo">
    <img src="assets/images/horseloop-logo.png" alt="HorseLoop" />
  </a>

  @if (registered) {
    <!-- Success State -->
    <div class="auth-header">
      <h1>{{ 'auth.register.success.title' | translate }}</h1>
      <p>{{ 'auth.register.success.subtitle' | translate }}</p>
    </div>

    <div class="alert alert-success">
      <i class="fa fa-check-circle"></i>
      <div>
        <strong>{{ 'auth.register.success.message' | translate }}</strong>
        <p class="mb-0">{{ 'auth.register.success.description' | translate }}</p>
      </div>
    </div>

    <button
      type="button"
      class="btn btn-outline"
      routerLink="/auth/login"
    >
      <i class="fa fa-arrow-left me-2"></i>
      {{ 'auth.common.backToLogin' | translate }}
    </button>
  } @else {
    <!-- Registration Form -->
    <div class="auth-header">
      <h1>{{ 'auth.register.title' | translate }}</h1>
      <p>{{ 'auth.register.subtitle' | translate }}</p>
    </div>

    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <!-- Name Fields (2 columns) -->
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label for="first_name" class="form-label">{{ 'auth.register.firstName' | translate }}</label>
            <input
              type="text"
              id="first_name"
              formControlName="first_name"
              class="form-control"
              [class.is-invalid]="form.get('first_name')?.invalid && form.get('first_name')?.touched"
              [placeholder]="'auth.register.firstNamePlaceholder' | translate"
              required
            />
            <span *ngIf="form.get('first_name')?.invalid && form.get('first_name')?.touched" class="invalid-feedback">
              {{ 'auth.register.firstNameRequired' | translate }}
            </span>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label for="last_name" class="form-label">{{ 'auth.register.lastName' | translate }}</label>
            <input
              type="text"
              id="last_name"
              formControlName="last_name"
              class="form-control"
              [class.is-invalid]="form.get('last_name')?.invalid && form.get('last_name')?.touched"
              [placeholder]="'auth.register.lastNamePlaceholder' | translate"
              required
            />
            <span *ngIf="form.get('last_name')?.invalid && form.get('last_name')?.touched" class="invalid-feedback">
              {{ 'auth.register.lastNameRequired' | translate }}
            </span>
          </div>
        </div>
      </div>

      <!-- Email Field -->
      <div class="form-group">
        <label for="email" class="form-label">{{ 'auth.common.email' | translate }}</label>
        <input
          type="email"
          id="email"
          formControlName="email"
          class="form-control"
          [class.is-invalid]="form.get('email')?.invalid && form.get('email')?.touched"
          [placeholder]="'auth.common.emailPlaceholder' | translate"
          required
        />
        <span *ngIf="form.get('email')?.invalid && form.get('email')?.touched" class="invalid-feedback">
          {{ 'auth.common.emailInvalid' | translate }}
        </span>
      </div>

      <!-- Phone Number Field -->
      <div class="form-group">
        <label for="phone_number" class="form-label">{{ 'auth.register.phoneNumber' | translate }}</label>
        <div class="phone-input-group">
          <select
            formControlName="phone_prefix"
            class="phone-prefix-select"
          >
            <!-- Nordic Countries -->
            <option value="+47">🇳🇴 +47</option>
            <option value="+46">🇸🇪 +46</option>
            <option value="+45">🇩🇰 +45</option>
            <option value="+358">🇫🇮 +358</option>
            <option value="+354">🇮🇸 +354</option>
            <!-- Europe -->
            <option value="+44">🇬🇧 +44</option>
            <option value="+49">🇩🇪 +49</option>
            <option value="+33">🇫🇷 +33</option>
            <option value="+31">🇳🇱 +31</option>
            <option value="+32">🇧🇪 +32</option>
            <option value="+43">🇦🇹 +43</option>
            <option value="+41">🇨🇭 +41</option>
            <option value="+39">🇮🇹 +39</option>
            <option value="+34">🇪🇸 +34</option>
            <option value="+351">🇵🇹 +351</option>
            <option value="+353">🇮🇪 +353</option>
            <option value="+48">🇵🇱 +48</option>
            <option value="+420">🇨🇿 +420</option>
            <option value="+36">🇭🇺 +36</option>
            <option value="+30">🇬🇷 +30</option>
            <option value="+372">🇪🇪 +372</option>
            <option value="+371">🇱🇻 +371</option>
            <option value="+370">🇱🇹 +370</option>
            <!-- North America -->
            <option value="+1">🇺🇸 +1</option>
            <!-- Oceania -->
            <option value="+61">🇦🇺 +61</option>
            <option value="+64">🇳🇿 +64</option>
            <!-- Other -->
            <option value="+7">🇷🇺 +7</option>
            <option value="+86">🇨🇳 +86</option>
            <option value="+81">🇯🇵 +81</option>
            <option value="+82">🇰🇷 +82</option>
            <option value="+91">🇮🇳 +91</option>
            <option value="+55">🇧🇷 +55</option>
            <option value="+52">🇲🇽 +52</option>
            <option value="+27">🇿🇦 +27</option>
            <option value="+971">🇦🇪 +971</option>
            <option value="+966">🇸🇦 +966</option>
            <option value="+90">🇹🇷 +90</option>
          </select>
          <input
            type="tel"
            id="phone_number"
            formControlName="phone_number"
            class="form-control phone-number-input"
            [class.is-invalid]="form.get('phone_number')?.invalid && form.get('phone_number')?.touched"
            [placeholder]="'auth.register.phonePlaceholder' | translate"
            required
          />
        </div>
        <span *ngIf="form.get('phone_number')?.invalid && form.get('phone_number')?.touched" class="invalid-feedback">
          {{ 'auth.register.phoneInvalid' | translate }}
        </span>
      </div>

      <!-- Password Field -->
      <div class="form-group">
        <label for="password" class="form-label">{{ 'auth.common.password' | translate }}</label>
        <div class="password-toggle">
          <input
            [type]="passwordVisible ? 'text' : 'password'"
            id="password"
            formControlName="password"
            class="form-control"
            [class.is-invalid]="form.get('password')?.hasError('passwordStrength') && form.get('password')?.touched"
            [placeholder]="'auth.register.createPassword' | translate"
            required
          />
          <i
            [class]="passwordVisible ? 'fa fa-eye-slash' : 'fa fa-eye'"
            class="password-toggle-icon"
            (click)="togglePasswordVisibility('password')"
          ></i>
        </div>
        <span *ngIf="form.get('password')?.hasError('passwordStrength') && form.get('password')?.touched" class="invalid-feedback">
          {{ 'auth.common.passwordStrengthError' | translate }}
        </span>
      </div>

      <!-- Confirm Password Field -->
      <div class="form-group">
        <label for="confirmPassword" class="form-label">{{ 'auth.common.confirmPassword' | translate }}</label>
        <div class="password-toggle">
          <input
            [type]="confirmPasswordVisible ? 'text' : 'password'"
            id="confirmPassword"
            formControlName="confirmPassword"
            class="form-control"
            [class.is-invalid]="form.hasError('passwordMismatch') && form.get('confirmPassword')?.touched"
            [placeholder]="'auth.common.confirmPasswordPlaceholder' | translate"
            required
          />
          <i
            [class]="confirmPasswordVisible ? 'fa fa-eye-slash' : 'fa fa-eye'"
            class="password-toggle-icon"
            (click)="togglePasswordVisibility('confirmPassword')"
          ></i>
        </div>
        <span *ngIf="form.hasError('passwordMismatch') && form.get('confirmPassword')?.touched" class="invalid-feedback">
          {{ 'auth.common.passwordMismatch' | translate }}
        </span>
      </div>

      <!-- Password Requirements -->
      <div class="password-requirements">
        <div class="password-requirements-title">{{ 'auth.common.passwordRequirements.title' | translate }}</div>
        <div class="password-requirement">
          <i class="fa fa-check-circle"></i>
          <span>{{ 'auth.common.passwordRequirements.minLength' | translate }}</span>
        </div>
        <div class="password-requirement">
          <i class="fa fa-check-circle"></i>
          <span>{{ 'auth.common.passwordRequirements.number' | translate }}</span>
        </div>
        <div class="password-requirement">
          <i class="fa fa-check-circle"></i>
          <span>{{ 'auth.common.passwordRequirements.special' | translate }}</span>
        </div>
      </div>

      <!-- Register Button -->
      <div class="form-group mt-4">
        <button
          type="submit"
          class="btn btn-primary"
          [disabled]="form.invalid || isSubmitting"
        >
          <span *ngIf="!isSubmitting">{{ 'auth.register.createAccount' | translate }}</span>
          <span *ngIf="isSubmitting">
            <i class="fa fa-spinner spinner me-2"></i>
            {{ 'auth.register.creatingAccount' | translate }}
          </span>
        </button>
      </div>
    </form>

    <!-- Divider -->
    <div class="auth-divider">
      <span>{{ 'auth.common.or' | translate }}</span>
    </div>

    <!-- Login Link -->
    <div class="auth-link">
      {{ 'auth.register.alreadyHaveAccount' | translate }} <a routerLink="/auth/login">{{ 'auth.register.signIn' | translate }}</a>
    </div>
  }
</div>
